import {
  RESET_INSIGHTS,
  RESET_INSIGHT,
  RESET_ERROR,
  GET_INSIGHTS,
  SET_INSIGHTS,
  API_ERROR,
  GET_INSIGHT,
  SET_INSIGHT,
  EDIT_INSIGHT,
  EDIT_INSIGHT_SUCCESS,
  CREATE_INSIGHT,
  CREATE_INSIGHT_SUCCESS,
  DELETE_INSIGHT,
  DELETE_INSIGHT_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorInsight: false,
  loadingInsight: false,
  dataInsight: null,
  successInsight: false,
};

const Insights = (state = initialState, action) => {
  switch (action.type) {
    case RESET_INSIGHTS:
      state = {
        ...state,
        errorInsight: false,
        loadingInsight: false,
        loadingInsightActivate: false,
        successInsight: false,
        dataInsight: null,
        dataInsightActivate: null,
        dataInsightDelete: null,
      };
      break;
    case RESET_INSIGHT:
      state = {
        ...state,
        errorInsight: false,
        loadingInsight: false,
        successInsight: false,
        dataInsightGetSet: null,
        dataInsightEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorInsight: false,
        loadingInsight: false,
        loadingInsightEditCreate: false,
        loadingInsightActivate: false,
        successInsight: false,
      };
      break;
    case GET_INSIGHTS:
      state = {
        ...state,
        errorInsight: false,
        loadingInsight: true,
        dataInsight: null,
      };
      break;
    case SET_INSIGHTS:
      state = {
        ...state,
        errorInsight: false,
        loadingInsight: false,
        dataInsight: action.payload,
      };
      break;
    case CREATE_INSIGHT:
      state = {
        ...state,
        errorInsight: false,
        loadingInsightEditCreate: true,
        dataInsightEditCreate: action.payload,
        successInsight: false,
      };
      break;
    case CREATE_INSIGHT_SUCCESS:
      state = {
        ...state,
        errorInsight: false,
        loadingInsightEditCreate: false,
        dataInsightEditCreate: action.payload,
        successInsight: true,
      };
      break;
    case GET_INSIGHT:
      state = {
        ...state,
        errorInsight: false,
        loadingInsight: true,
        dataInsightGetSet: null,
      };
      break;
    case SET_INSIGHT:
      state = {
        ...state,
        errorInsight: false,
        loadingInsight: false,
        dataInsightGetSet: action.payload,
      };
      break;
    case EDIT_INSIGHT:
      state = {
        ...state,
        errorInsight: false,
        loadingInsightEditCreate: true,
        dataInsightEditCreate: action.payload,
        successInsight: false,
      };
      break;
    case EDIT_INSIGHT_SUCCESS:
      state = {
        ...state,
        errorInsight: false,
        loadingInsightEditCreate: false,
        dataInsightEditCreate: action.payload,
        successInsight: true,
      };
      break;
    case DELETE_INSIGHT:
      state = {
        ...state,
        errorInsight: false,
        loadingInsightDelete: true,
        dataInsightDelete: action.payload,
        successInsight: false,
      };
      break;
    case DELETE_INSIGHT_SUCCESS:
      state = {
        ...state,
        errorInsight: false,
        loadingInsightDelete: false,
        dataInsightDelete: action.payload,
        successInsight: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorInsight: action.payload,
        loadingInsight: false,
        successInsight: false,
      };
      break;
    default:
      // state = { ...state, error: false, loading: false };
      break;
  }
  return state;
};

export default Insights;
